<template>

    <Flipbook class="flipbook" :pages="pages($i18n.locale)" ref="flipbook" :zooms="zooms" :perspective="perspective">
    </Flipbook>
</template>

<script>
    // @ is an alias to /src
    import Flipbook from 'flipbook-vue';

    const pagesUA = [
        null,
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmFront.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmPage1.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmPage2.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmPage3.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmPage4.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmPage5.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmPage6.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmBack.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmFront.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmPage1.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmPage2.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmPage3.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmPage4.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmPage5.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmPage6.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmBack.jpg',
    ];
    const pagesDE = [
        null,
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmFrontDE.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmPage1DE.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmPage2DE.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmPage3DE.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmPage4DE.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmPage5DE.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmPage6DE.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmBackDE.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmFrontDE.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmPage1DE.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmPage2DE.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmPage3DE.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmPage4DE.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmPage5DE.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmPage6DE.jpg',
        'https://www.hovrashok.iena.info/assets/LayoutSquare_148x148_mmBackDE.jpg',
    ];
    const pages = (locale) => {
        if (locale === 'ua') return pagesUA;
        if (locale === 'de') return pagesDE;
        return [];
    };
    export default {
        name: 'Home',
        components: {
            Flipbook
        },
        data() {
            return {
                pages: pages,
                zooms: [1],
                perspective: 5000
            };
        },
        methods: {},
        created() {
            document.title = this.$t('ziesel');
        },
    };
</script>
<style>
    .flipbook {
        align-content: center;
        height: 90vh;
        background-color: dimgray;
        margin: 0 60px 60px 60px;
        padding: 60px 0 60px 0;
        box-sizing: border-box;
    }
</style>
